// utils/notifications.ts
const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

export const requestNotificationPermission = async () => {
	if (!('Notification' in window)) return false;

	if (isIOS && !isStandalone) return false;

	if (Notification.permission === 'default') {
		await Notification.requestPermission();
		return true;
	}
};

// export const showNotification = (title: string, options?: NotificationOptions) => {
// 	console.log("----- New Notification Abovev Received -----")
// 	console.log(title, options)
// 	if (Notification.permission === 'granted') {
// 		console.log("----- New Notification Received -----")
// 		console.log(title, options)
// 		new Notification(title, options);
// 	} else {
// 		console.log('Notification permission denied.');
// 		requestNotificationPermission();
// 	}
// };

export const showNotification = (title: string, options?: NotificationOptions) => {
	console.log("----- New Notification Abovev Received -----")
	console.log(title, options)
	if (!("Notification" in window)) return;

	if (Notification.permission === "granted" && document.hidden) {
		console.log("----- New Notification Received -----")
		console.log(title, options)
		new Notification(title, options);
	}
};